import type { ReactNode } from 'react';
import { T, F } from './tokens';

interface ModuleShellProps {
  children: ReactNode;
}

export function ModuleShell({ children }: ModuleShellProps) {
  return (
    <div style={{
      minHeight: '100vh',
      background: T.bg,
      fontFamily: F.body,
      color: T.text,
      overflowX: 'hidden',
    }}>
      {children}
    </div>
  );
}
